import { useState, useCallback, useRef, useEffect } from "react";
import { GoogleMap, useJsApiLoader, Marker } from "@react-google-maps/api";
import styles from "./googlemap.module.scss";
import Button from "../Button/Button";
import { MdOutlineMyLocation } from "react-icons/md";
import {
  useSetLocationData,
  useUpdateLocationData,
} from "../../hooks/partnerHook/usePartner";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { closeMaps } from "../../store/Partner/modalSlice";

const libraries = ["places"];

export default function GoogleMapComponent() {
  const showGoogleMap = useSelector((state) => state.modal.showGoogleMap);
  console.log("GoogleMapComponent Mounted, showGoogleMap:", showGoogleMap);


  const [map, setMap] = useState(null);
  const [center, setCenter] = useState({ lat: 40.7128, lng: -74.006 }); // Default to New York City
  const [marker, setMarker] = useState(null);
  const [address, setAddress] = useState("");
  const searchBoxRef = useRef(null);
  const inputRef = useRef(null);
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.partner.user);
  let partnerId = null;

  if (userData) {
    partnerId = userData.partner.id;
  }

  useEffect(() => {
    if (userData && userData?.partner?.location) {
      setCenter((prevData) => ({
        lat: userData.partner.location.location_lat,
        lng: userData.partner.location.location_long,
      }));
      setMarker({
        lat: userData.partner.location.location_lat,
        lng: userData.partner.location.location_long,
      });
    }
  }, [userData]);

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries: libraries,
  });
  console.log("Google Maps API loaded:", isLoaded);

  const onLoad = useCallback((map) => {
    setMap(map);
  }, []);

  const onUnmount = useCallback(() => {
    setMap(null);
  }, []);

  useEffect(() => {
    if (inputRef.current && isLoaded) {
      const autocomplete = new window.google.maps.places.Autocomplete(
        inputRef.current
      );
      // autocomplete.bindTo("bounds", map);

      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();
        if (!place.geometry || !place.geometry.location) {
          alert("No details available for input: '" + place.name + "'");
          return;
        }

        // Center map on selected location and add marker
        const location = place.geometry.location;
        map.setCenter(location);
        map.setZoom(15);
        setMarker({
          lat: location.lat(),
          lng: location.lng(),
        });
        setAddress(place.formatted_address);
      });
    }
  }, [inputRef, map, isLoaded]);

  const detectLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          console.log("User location detected:", position.coords);
          const newPos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          setCenter(newPos);
          setMarker(newPos);
          getAddressFromLatLng(newPos);
        },
        (error) => {
          console.error("Error detecting location:", error);
        }
      );
    } else {
      console.warn("Geolocation is not supported by this browser.");
    }
  };

  const getAddressFromLatLng = (latLng) => {
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ location: latLng }, (results, status) => {
      console.log("Geocoding Results:", results);
      if (status === "OK" && results[0]) {
        setAddress(results[0].formatted_address);
      } else {
        console.error("Geocoder failed:", status);
      }
    });
  };

  const handleMapClick = (e) => {
    const clickedPos = {
      lat: e.latLng.lat(),
      lng: e.latLng.lng(),
    };
    setMarker(clickedPos);
    getAddressFromLatLng(clickedPos);
  };

  const {
    mutate: setLocationData,
    isSuccess: saveSuccess,
    isError: saveError,
  } = useSetLocationData();
  const {
    mutate: updateLocationData,
    isSuccess: updateSuccess,
    isError: updateError,
  } = useUpdateLocationData();

  const handleSelectedLocation = async () => {
    console.log(
      "Saving Location Data for partnerId:",
      partnerId,
      "Marker:",
      marker
    );

    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ location: marker }, (results, status) => {
      if (status === "OK" && results[0]) {
        console.log("Final Location Data:", results[0]);

        const addressComponents = results[0].address_components;
        const userLocation = {
          localArea:
            addressComponents.find((comp) =>
              comp.types.includes("sublocality_level_1")
            )?.long_name || "N/A",
          locality:
            addressComponents.find((comp) => comp.types.includes("locality"))
              ?.long_name || "N/A",
          district:
            addressComponents.find((comp) =>
              comp.types.includes("administrative_area_level_3")
            )?.long_name || "N/A",
          pincode:
            addressComponents.find((comp) => comp.types.includes("postal_code"))
              ?.long_name || "N/A",
          state:
            addressComponents.find((comp) =>
              comp.types.includes("administrative_area_level_1")
            )?.long_name || "N/A",
          latitude: marker.lat,
          longitude: marker.lng,
        };

        console.log("User Location Object:", userLocation);

        if (!userData.partner.location) {
          setLocationData({ partnerId, locationData: userLocation });
        } else {
          updateLocationData({ partnerId, locationData: userLocation });
        }
      } else {
        console.error("Error fetching address details:", status);
      }
    });
  };

  useEffect(() => {
    console.log("Save Success:", saveSuccess, "Update Success:", updateSuccess);

    if (saveSuccess || updateSuccess) {
      toast.success("Map details saved successfully!");

      dispatch(closeMaps());
    }
  }, [saveSuccess, updateSuccess]);

  return (
    <div className="container-background content-center ">
      <div className={styles.mapContainer}>
        <button
          className={styles.closebtn}
          onClick={() => {
         
              dispatch(closeMaps());
            
           
            console.log("bnd krdiya bnd krdiya")
          }}
        >
          Close
        </button>
        <div className={styles.componentHeader}>
          <div className={styles.searchContainer}>
            {isLoaded && (
              <input
                ref={inputRef}
                type="search"
                placeholder="Search a place..."
                className={styles.searchInput}
              />
            )}
            <Button
              label=""
              handleClick={detectLocation}
              icon={<MdOutlineMyLocation />}
              className={styles.detectLocationBtn}
            />
          </div>
          {address && (
            <div className={styles.addressDisplay}>
              <p className={styles.addressText}>
                <b>Selected Address:</b> {address}
              </p>
              <Button
                className={styles.confirmLocationBtn}
                handleClick={handleSelectedLocation}
                label="Confirm Location"
              />
            </div>
          )}
        </div>
        {isLoaded ? (
          <GoogleMap
            mapContainerStyle={{ width: "100%", height: "100%" }}
            center={center}
            zoom={10}
            onLoad={onLoad}
            onUnmount={onUnmount}
            options={{
              fullscreenControl: false,
              streetViewControl: false,
              mapTypeControl: false,
              gestureHandling: "cooperative",
            }}
            onClick={handleMapClick}
          >
            {marker && <Marker position={marker} />}
          </GoogleMap>
        ) : (
          <div>Loading...</div>
        )}
      </div>
    </div>
  );
}
